module.exports = __webpack_public_path__ + "img/prize.549f44da.svg";